import { Link } from 'react-router-dom';
import { Microscope } from 'lucide-react';
import { SearchBar } from './SearchBar';
import './Header.css';

export const Header = () => {
  return (
    <header className="app-header">
      <div className="header-content">
        <Link to="/" className="header-logo">
          <Microscope className="logo-icon" size={24} />
          <span className="logo-text">POM Data</span>
        </Link>
        
        <div className="header-search">
          <SearchBar />
        </div>
      </div>
    </header>
  );
};
